import Http from "@/api/http";

export default {
  /* 人脸机设备 */
  /* 列表 */
  faceDeviceFindByPage: params => {
    return Http.POST("/faceDevice/findByPage", params);
  },
  /* 新增/修改 */
  faceDeviceSave: params => {
    return Http.POST("/faceDevice/save", params);
  },
  /* 详情 */
  faceDeviceFindOne: params => {
    return Http.GET("/faceDevice/findOne", params);
  },
  /* 删除 */
  faceDeviceDelete: params => {
    return Http.GET("/faceDevice/delete", params);
  },
  /* 查询某个人脸机上面人员信息 */
  findFaceDevicePersonnelInfo: params => {
    return Http.POST("/workerinfo/findFaceDevicePersonnelInfo", params);
  },
  /* 添加人员信息到人脸机 */
  addPersonnelInfoToFaceDevice: params => {
    return Http.POST("/faceDevice/addPersonnelInfoToFaceDevice", params);
  },
  /* 重新授权人员信息到人脸机 */
  authorizePersonnelInfoToFaceDevice: params => {
    return Http.GET("/faceDevice/authorizePersonnelInfoToFaceDevice", params);
  },
  /* 批量删除人脸机设备绑定人员 */
  deleteDevicePersonnelRecord: params => {
    return Http.GET("/faceDevice/deleteDevicePersonnelRecord", params);
  },
};
